import type { MetricView } from '../api/types'
import { Select } from './Select'

/** Это выбор независимой серии Instagram, не переключение сборщика источника. */
export function MetricViewSelect({ value, onChange }: { value: MetricView; onChange: (value: MetricView) => void }) {
  return <Select label="Метрики Instagram" value={value} onChange={(e) => onChange(e.target.value as MetricView)}>
    <option value="legacy">Instagram · Apify</option>
    <option value="meta">Instagram · Meta</option>
  </Select>
}
